import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type MarriageIconProps = CreateIconComponentProps;
export const MarriageIcon: React.FC<MarriageIconProps> = ({
  title = 'Marriage',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7.667 11H7.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-.167"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16.5 11v0c.882 0 1.65.6 1.864 1.455l1.015 4.06A2 2 0 0 1 17.439 19H6.561a2 2 0 0 1-1.94-2.485l1.014-4.06A1.921 1.921 0 0 1 7.5 11v0"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m4.444 18-.363 1.54A2 2 0 0 0 6.027 22h11.946a2 2 0 0 0 1.946-2.46L19.556 18"
    />
    <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M8 16h8" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 15.5c0-1.57-1.343-2.842-3-2.842S9 13.93 9 15.5"
    />
    <path
      fill="currentColor"
      d="M14.58 10.96a.8.8 0 1 0-1.125-1.136l1.126 1.137Zm-2.478 1.33-.563.568a.8.8 0 0 0 1.126 0l-.563-.568ZM10.75 9.824a.8.8 0 0 0-1.125 1.137l1.125-1.137Zm-1.12 1.142a.8.8 0 0 0 1.116-1.147l-1.116 1.147Zm2.473-2.25-.642.476a.8.8 0 0 0 1.282.004l-.64-.48Zm1.355 1.107a.8.8 0 0 0 1.121 1.142l-1.12-1.142Zm-.002.001-1.916 1.897 1.126 1.137 1.916-1.897-1.126-1.137Zm-.79 1.897L10.75 9.824l-1.126 1.137 1.915 1.897 1.126-1.137Zm-1.92-1.902a.477.477 0 0 1-.123-.484L9.094 8.86a2.077 2.077 0 0 0 .535 2.106l1.116-1.147Zm-.123-.484a.477.477 0 0 1 .375-.328l-.269-1.577a2.077 2.077 0 0 0-1.634 1.43l1.528.475Zm.375-.328a.477.477 0 0 1 .463.185l1.284-.954a2.077 2.077 0 0 0-2.016-.808l.269 1.577Zm1.745.189a.477.477 0 0 1 .462-.183l.272-1.577a2.077 2.077 0 0 0-2.013.798l1.279.962Zm.462-.183c.176.03.321.157.374.328l1.528-.477a2.077 2.077 0 0 0-1.63-1.428l-.272 1.577Zm.374.328a.477.477 0 0 1-.12.482l1.12 1.142c.556-.546.76-1.358.528-2.101l-1.528.477Z"
    />
  </CreateIconComponent>
);
